export default __webpack_public_path__ + "static/media/Fulfillment_Quiken_Entregamos-12.5f54ebe8.svg";